import { fetchAdsMetadata } from '../api/adsMetaApi';

export const RECEIVE_INLINE_STATUS = 'RECEIVE_INLINE_STATUS';
export const RECEIVE_PARENT_DOMAIN = 'RECEIVE_PARENT_DOMAIN';
export const RECEIVE_PARENT_PAGE_META = 'RECEIVE_PARENT_PAGE_META';

export const receiveInlineStatus = (status) => ({
    type: RECEIVE_INLINE_STATUS,
    status
});

export const receiveParentDomain = (domain) => ({
    type: RECEIVE_PARENT_DOMAIN,
    domain
});

export const receivePageMeta = (pageMeta) => ({
    type: RECEIVE_PARENT_PAGE_META,
    pageMeta
});

export const fetchPageMeta = (path, domain) => dispatch => {
    return fetchAdsMetadata(path, domain)
        .then(res => {
            dispatch(receivePageMeta(res.data));
        });
};